// UNUSED (I guess)
import request from '@/API/';

export default {
  getBackendData: (payload) => {
    return request.get(`data/list?f=${payload.startDate}&q=${payload.query}&t=${payload.endDate}&c=${payload.client}&o=0&l=500&a=${payload.app}&i=${payload.interface}`)
  },
  getClients: () => {
    return request.get(`user/clients?s=1`)
  }
};
